export const shapeSchema = {
    title: 'shape',
    version: 0,
    description: 'AMB bus route shapes cache',
    type: 'object',
    primaryKey: 'id',
    properties: {
        id: {
            type: 'string',
        },
        createdAt: {
            type: 'number',
        },
        points: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    shape_pt_lat: {
                        type: 'number',
                    },
                    shape_pt_lon: {
                        type: 'number',
                    },
                    shape_pt_sequence: {
                        type: 'number',
                    },
                },
            },
        },
    },
    required: ['id', 'createdAt', 'points'],
};
